import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { ApiInterceptor } from './utils/interceptors';
import { ErrorService } from './shared/services/error.service';
import { ApiModule, Configuration } from './utils/api';
import { RECAPTCHA_SETTINGS, RECAPTCHA_V3_SITE_KEY, RecaptchaSettings } from 'ng-recaptcha';

export const appConfig: ApplicationConfig = {
    providers: [
        // angular / interceptors
        provideHttpClient(withInterceptors([ApiInterceptor])),
        // plugins
        importProvidersFrom(
            ApiModule.forRoot(() => {
                return new Configuration({ basePath: '/api' });
            })
        ),
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LcuJX0rAAAAAAlSPGuPZlLhI-5tsvLdn-DgT-RY' },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: { siteKey: '6LfxKH0rAAAAABY9VCQEMn4XKs7psednmAf2zV2g' } as RecaptchaSettings
        },

        // error handler
        { provide: ErrorHandler, useClass: ErrorService }
    ]
};
